var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "9819cac739a1ed7db00e7a82929a498aaf8f713b"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-site@roadie"] = {
  id: "9819cac739a1ed7db00e7a82929a498aaf8f713b"
};